import { InputAdornment, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useController } from "react-hook-form";

const useStyles = makeStyles({
  helperText: {
    fontSize: ".75rem",
  },
});

const MyTextField = ({
  control,
  name,
  rules,
  helperText,
  disabled,
  label,
  fullWidth,
  endAdornment,
  rows,
  multiline,
  type,
  autoComplete,
  placeholder,
  onKeyPress,
  variant,
  autoFocus,
  useUpperCase,
  useTrim,
  InputProps,
  onPaste,
  onPasteCapture,
  required,
  inputProps,
  id,
  minRows,
  onFocus,
  onChange,
  labelNoWrap,
}: any) => {
  const classes = useStyles();

  const { field, fieldState } = useController({
    name: name,
    control: control,
    rules: rules,
  });

  console.log(fieldState.isDirty, fieldState.isTouched);

  const onChangeInput = (e) => {
    if (useTrim && e.target.value) {
      e.target.value = e.target.value.trim().split(" ").join("");
    }

    if (useUpperCase && e.target.value) {
      e.target.value = e.target.value.toUpperCase();
    }

    field.onChange(e);

    onChange && onChange(e);
  };

  return (
    <TextField
      id={id}
      name={field.name}
      minRows={minRows}
      value={field.value}
      onBlur={field.onBlur}
      inputRef={field.ref}
      required={required}
      onChange={onChangeInput}
      autoFocus={autoFocus}
      onKeyPress={onKeyPress}
      disabled={disabled}
      type={type || "text"}
      placeholder={placeholder}
      autoCapitalize="none"
      onFocus={onFocus}
      InputProps={
        InputProps
          ? InputProps
          : {
              inputProps: {
                autoComplete: autoComplete || "new-password",
                autoCapitalize: "off",
                ...inputProps,
              },
              endAdornment: endAdornment ? (
                <InputAdornment style={{ height: "100%" }} position="end">
                  {endAdornment}
                </InputAdornment>
              ) : undefined,
            }
      }
      helperText={helperText}
      FormHelperTextProps={{
        className: classes.helperText,
      }}
      InputLabelProps={{
        shrink: true,
        style: {
          whiteSpace: labelNoWrap,
        },
      }}
      label={label}
      fullWidth={fullWidth}
      rows={rows}
      multiline={multiline}
      variant={variant}
      onPaste={onPaste}
      onPasteCapture={onPasteCapture}
      autoComplete="off"
    />
  );
};

export default MyTextField;
